/**
 * Normalizes destination/city values for display on image badges.
 * Returns empty string when there is no reliable label (callers hide the badge).
 */

const PLACEHOLDER_LABELS = new Set([
  "לא צוין",
  "לא צוינה",
  "N/A",
  "n/a",
  "עיר לא זמינה",
  "מיקום לא זמין",
  "יעד",
  "מלון",
]);

/**
 * @param {unknown} value — string, LDS destination object, or null
 * @returns {string}
 */
export function normalizeDestinationLabel(value) {
  if (value == null) return "";
  if (typeof value === "object") {
    const s =
      value.CITYNAME_HEB ||
      value.CITYNAME ||
      value.AIRPORTNAME ||
      value.name;
    return normalizeDestinationLabel(s);
  }
  const t = String(value).trim();
  if (!t || PLACEHOLDER_LABELS.has(t)) return "";
  return t;
}

/**
 * Prefer hotel fields, then arrival city from outbound flight (packages).
 * @param {object} [hotel]
 * @param {object} [linkedFlights]
 * @returns {string}
 */
export function resolveDestinationFromLdsHotelAndFlights(hotel = {}, linkedFlights) {
  const leg =
    linkedFlights?.flight?.[0]?.leg ||
    linkedFlights?.outboundFlight ||
    null;

  return (
    normalizeDestinationLabel(hotel.hotelCity) ||
    normalizeDestinationLabel(hotel.city) ||
    normalizeDestinationLabel(hotel.destination) ||
    (typeof hotel.location === "string"
      ? normalizeDestinationLabel(hotel.location)
      : "") ||
    normalizeDestinationLabel(leg?.arrCity)
  );
}
